<template>
  <div class = "main-container-content-nonEmptyState">
    <div v-if = "!mainLoader">
        <div class = "nonEmptyStateGrowth mb-15">
            <div class = "images-container">
                <img src = '/img/growthIcon-4f.svg' id = "growthImage">
                <p class = "referralLinkText">Growth</p>
            </div>
            <div v-if = "growthExpectedInterest > 0" @click="growthDataToggle" class = "values-container">
                <p class = "growth-account-value">&#x20B9;{{growthEarningsValue | localeAmountPaisa }}</p>
                <v-icon v-if = "!displayGrowth" class="material-icons-round bannerIcons">
                    navigate_next
                </v-icon>
                <v-icon v-else class="material-icons-round bannerIcons">
                    expand_more
                </v-icon>
            </div>
        </div>
        <div class = "expectedEarningsTable" v-if = "displayGrowth" @scroll="loadMoreGrowth">
            <v-data-table
                :headers="expectedEarningsHeaders"
                :items="growthEarningsData"
                :items-per-page="growthEarningsItemsPerPage"
                :header-props="{ sortIcon: null }"
                :hide-default-footer="true"
                mobile-breakpoint="0"
            >
                <template v-slot:item.combinedDate="{ item }">
                    {{ item.combinedDate | earningsFormatDate }}
                </template>
                <template v-slot:item.expectedPrincipal="{ item }">
                    &#x20B9;{{ item.expectedPrincipal | localeAmountPaisa }}
                </template>
                <template v-slot:item.expectedEarnings="{ item }">
                    &#x20B9;{{ item.expectedEarnings | localeAmountPaisa }}
                </template>
                <template v-slot:item.interest="{ item }">
                    <div class = "earningContainer">
                        <span :class="getStatusColor(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings)">
                            &#x20B9;{{ changeInterest(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings) | localeAmountPaisa }}
                        </span>
                        <v-tooltip class = "tooltipContainer" max-width = "300px" top color="#ffffff">
                            <template v-slot:activator="{on, attrs}">
                                <img v-bind="attrs" v-on="on" class = "cautionImage" v-if="calculateEarningStatus(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings)" src = "/img/caution_icon.svg" >
                            </template>
                            <div>
                                <div class = "tooltipSubContainer">
                                    <img src = "/img/caution_featured_icon.svg" style = "font-size: 38px; color: #3576C2;" class="cautionImageContainer material-icons-round">
                                </div>
                                <p class = "earningsText">More earnings are on their way!</p>
                                <span class = "spanText">{{getRepaymentsText(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings, item.combinedDate)}}</span>
                            </div>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </div>
        <div v-if="isLoadingGrowth" class = "loaderContainer">
                <v-progress-circular
                    indeterminate
                    color="#13285e"
                ></v-progress-circular>
        </div>
        <div class = "nonEmptyStateGrowth mb-5">
            <div class = "images-container">
                <v-icon class="material-icons-round bannerIcons mr-5">
                    calendar_month
                </v-icon>
                <p class = "referralLinkText">Income</p>
            </div>
            <div v-if = "incomeExpectedInterest > 0" @click="incomeDataToggle" class = "values-container">
                <p class = "growth-account-value">&#x20B9;{{incomeEarningsValue | localeAmountPaisa}}</p>
                <v-icon v-if = "!displayIncome" class="material-icons-round bannerIcons">
                    navigate_next
                </v-icon>
                <v-icon v-else class="material-icons-round bannerIcons">
                    expand_more
                </v-icon>
            </div>
        </div>
        <div class = "expectedEarningsTable" v-if = "displayIncome" @scroll="loadMoreIncome">
            <v-data-table
                :headers="expectedEarningsHeaders"
                :items="incomeEarningsData"
                :items-per-page="incomeEarningsItemsPerPage"
                :header-props="{ sortIcon: null }"
                :hide-default-footer="true"
                mobile-breakpoint="0"
            >
                <template v-slot:item.combinedDate="{ item }">
                    {{ item.combinedDate | earningsFormatDate }}
                </template>
                <template v-slot:item.expectedPrincipal="{ item }">
                    &#x20B9;{{ item.expectedPrincipal | localeAmountPaisa }}
                </template>
                <template v-slot:item.expectedEarnings="{ item }">
                    &#x20B9;{{ item.expectedEarnings | localeAmountPaisa }}
                </template>
                <template v-slot:item.interest="{ item }">
                    <div class = "earningContainer">
                        <span :class="getStatusColor(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings)">
                            &#x20B9;{{ changeInterest(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings) | localeAmountPaisa }}
                        </span>
                        <v-tooltip class = "tooltipContainer" max-width = "300px" top color="#ffffff">
                            <template v-slot:activator="{on, attrs}">
                                <img v-bind="attrs" v-on="on" class = "cautionImage" v-if="calculateEarningStatus(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings)" src = "/img/caution_icon.svg" >
                            </template>
                            <div>
                                <div class = "tooltipSubContainer">
                                    <img src = "/img/caution_featured_icon.svg" style = "font-size: 38px; color: #3576C2;" class="material-icons-round">
                                </div>
                                <p class = "earningsText">More earnings are on their way!</p>
                                <span class = "spanText">{{getRepaymentsText(item.interest, item.principal, item.expectedPrincipal, item.expectedEarnings, item.combinedDate)}}</span>
                            </div>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </div>
        <div v-if="isLoadingIncome" class = "loaderContainer">
                <v-progress-circular
                    indeterminate
                    color="#13285e"
                ></v-progress-circular>
        </div>
    </div>
    <div v-else class = "loaderContainer mb-10">
        <v-progress-circular
            indeterminate
            color="#13285e"
        ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    props: {
        earnings: Number,
        expectedEarnings: Number
    },
    data () {
        return {
            growthExpectedInterest: 0,
            incomeExpectedInterest: 0,
            mainLoader: true,
            growthEarningsValue: null,
            displayGrowth: false,
            incomeEarningsValue: null,
            displayIncome: false,
            growthEarningsData: [],
            growthEarningsTotalRecords: null,
            growthEarningsPage: 1,
            growthEarningsItemsPerPage: 10,
            incomeEarningsData: [],
            incomeEarningsTotalRecords: null,
            incomeEarningsPage: 1,
            incomeEarningsItemsPerPage: 10,
            limitDocuments: 10,
            isLoadingIncome: false,
            isLoadingGrowth: false,
            incomeHeight: 0,
            limitDocumentsExpected: 3,
            expectedEarningsHeaders: [
                {
                    text: 'Date',
                    value: 'combinedDate',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Principal',
                    value: 'expectedPrincipal',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Earnings',
                    value: 'expectedEarnings',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Received',
                    value: 'interest',
                    align: 'left',
                    sortable: false,
                    class: ['bold', 'sticky-header']
                }
            ]
        }
    },
    mounted () {
        this.earningsSummary()
    },
    beforeDestroy () {
        this.growthEarningsValue = null
        this.displayGrowth = false
        this.incomeEarningsValue = null
        this.displayIncome = false
        this.expectedEarningsData = []
        this.expectedEarningsTotalRecords = null
        this.expectedEarningsPage = 1
        this.expectedEarningsItemsPerPage = 10
        this.growthEarningsData = []
        this.growthEarningsTotalRecords = null
        this.growthEarningsPage = 1
        this.growthEarningsItemsPerPage = 10
        this.incomeEarningsData = []
        this.incomeEarningsTotalRecords = null
        this.incomeEarningsPage = 1
        this.incomeEarningsItemsPerPage = 10
        this.limitDocuments = 10
        this.limitDocumentsExpected = 6
        this.isLoadingIncome = false
        this.isLoadingGrowth = false
        this.growthExpectedInterest = 0
        this.incomeExpectedInterest = 0
        this.incomeInterest = 0
        this.growthInterest = 0
    },
    methods: {
        earningsSummary () {
            this.$store.commit('isLoading')
            lenderService.earningsSummaryData().then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.growthExpectedInterest = response.data.growth.interest
                    this.incomeExpectedInterest = response.data.income.interest
                    this.growthEarningsValue = response.data.growth.paidInterest
                    this.incomeEarningsValue = response.data.income.paidInterest
                    this.mainLoader = false
                }
            })
        },
        growthDataToggle () {
            if (this.growthEarningsValue > 0 || this.growthExpectedInterest > 0) {
                this.displayGrowth = !this.displayGrowth
                if (this.displayGrowth === true) {
                    this.isLoadingGrowthMain = true
                    this.getGrowthEarningsData()
                }
            }
        },
        incomeDataToggle () {
            if (this.incomeEarningsValue > 0 || this.incomeExpectedInterest > 0) {
                this.displayIncome = !this.displayIncome
                if (this.displayIncome === true) {
                    this.getIncomeEarningsData()
                }
            }
        },
        changeInterest (interest, principal, expectedPrincipal, expectedInterest) {
            var finalInterest = 0
            if (interest > 0 || principal > 0) {
                finalInterest = interest + principal
            } else {
                finalInterest = expectedPrincipal + expectedInterest
            }
            return finalInterest
        },
        getRepaymentsText (interest, principal, expectedPrincipal, expectedInterest, combinedDate) {
            const currentDate = new Date()
            const finalCombinedDate = new Date(combinedDate)
            const currentMonth = currentDate.getMonth()
            const currentYear = currentDate.getFullYear()

            const combinedMonth = finalCombinedDate.getMonth()
            const combinedYear = finalCombinedDate.getFullYear()

            if (interest + principal >= expectedPrincipal + expectedInterest) {
                return ''
            } else if (interest + principal > 0 && (currentMonth === combinedMonth && currentYear === combinedYear)) {
                return 'Repayments come through the month on different dates. Check this section on the last date of the month for all due earnings.'
            } else {
                return 'Some loan(s) in your portfolio are experiencing repayment delays. IndiaP2P is actively in communication with these borrowers to ensure that due repayments are made.'
            }
        },
        calculateEarningStatus (interest, principal, expectedPrincipal, expectedInterest) {
            if (interest + principal >= expectedPrincipal + expectedInterest) {
                return false
            } else if (interest + principal > 0) {
                return true
            } else {
                return false
            }
        },
        getStatusColor (interest, principal, expectedPrincipal, expectedInterest) {
            if (interest + principal >= expectedPrincipal + expectedInterest) {
                return 'greenColor'
            } else if (interest + principal > 0) {
                return 'yellowColor'
            } else {
                return 'bold'
            }
        },
        getGrowthEarningsData () {
            if (this.growthEarningsTotalRecords !== this.growthEarningsData.length) {
                this.isLoadingGrowth = true
                const query = 'itemsPerPage=' + this.limitDocuments + '&page=' + this.growthEarningsPage
                lenderService.getGrowthEarningsData(query).then((response) => {
                    if (response.status === 200) {
                        this.$store.commit('isNotLoading')
                        this.isLoadingGrowth = false
                        this.isLoadingGrowthMain = false
                        this.growthEarningsData = response.data.growthData
                        this.growthEarningsTotalRecords = response.data.totalRecords
                        this.growthEarningsItemsPerPage = response.data.growthData.length
                    }
                })
            } else {
                this.$store.commit('isNotLoading')
            }
        },
        getIncomeEarningsData () {
            if (this.incomeEarningsTotalRecords !== this.incomeEarningsData.length) {
                this.isLoadingIncome = true
                const query = 'itemsPerPage=' + this.limitDocuments + '&page=' + this.incomeEarningsPage
                lenderService.getIncomeEarningsData(query).then((response) => {
                    if (response.status === 200) {
                        this.isLoadingIncome = false
                        this.$store.commit('isNotLoading')
                        this.incomeEarningsData = response.data.incomeData
                        this.incomeEarningsTotalRecords = response.data.totalRecords
                        this.incomeEarningsItemsPerPage = response.data.incomeData.length
                    }
                })
            } else {
                this.$store.commit('isNotLoading')
            }
        },
        loadMoreGrowth (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                this.growthEarningsPage += 1
                this.getGrowthEarningsData()
            }
        },
        loadMoreIncome (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                this.incomeEarningsPage += 1
                this.getIncomeEarningsData()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

    .cautionImageContainer {
        margin-bottom: 8px !important;
    }
    .tooltipSubContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .v-tooltip__content {
        opacity: 1 !important;
        text-align: center !important;
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
    }
    .tooltipContainer {
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
        background-color: #ffffff !important;
    }
    .earningsText {
        text-align: center;
        margin-bottom: 4px !important;
        font-weight: 600;
        font-size: 16px;
        color: #0f0f0f
    }
    .spanText {
        color: #8c8c8c;
        text-align: center !important;
        font-size: 11px !important
    }
    .cautionImage {
        margin-left : 10px;
        width: 16px !important;
        height: 16px !important;
        cursor: pointer;
    }
    .earningContainer {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
        display: none;
    }
    ::v-deep .v-data-table__wrapper {
        overflow: unset;
    }
    ::v-deep .v-data-table__wrapper .sticky-header {
        background: #f2f6ff !important;
        position: sticky;
        top: 0;
    }
    .bold {
        font-weight: 600
    }
    .loaderContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .yellowColor {
        color: #ffcb05;
        font-weight: 600
    }
    .greenColor {
        color: #00992a;
        font-weight: 600
    }
    .expectedEarningsTable {
        max-height: 250px;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .expectedEarningsTable::-webkit-scrollbar {
        width: 0 !important
    }
    .transactionAmount {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 0px;
        font-size: 16px;
        font-weight: 500;
        color: #4f4f4f
    }
    .fundDate {
        font-size: 12px;
        text-transform: capitalize;
        color: #8c8c8c;
        margin-bottom: 0px;
    }
    .description {
        font-weight: 600;
        font-size: 16px;
        color: #232323;
        text-transform: capitalize;
        margin-bottom: 2px;
    }
    .risk-container {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .incomeTransContainer {
        display: flex;
        flex-direction: row;
        padding: 6px;
        padding-bottom: 12px;
        padding-right: 28px;
    }
    .incomeWhole {
        overflow-y: scroll;
        max-height: 281px;
    }
    .incomeWhole::-webkit-scrollbar {
        width: 0 !important
    }
    ::v-deep .primary {
        background-color: #002fa7 !important;
        border-color: #002fa7 !important;
    }
    ::v-deep .v-pagination__item {
        height: 25px;
        min-width: 25px;
        font-size: 14px;
    }
    ::v-deep .v-pagination__navigation {
        height: 25px;
        width: 25px
    }
    ::v-deep .v-icon.v-icon {
        font-size: 14px;
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        color: #6a6a6a;
        font-size: 13px
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        height: 38px;
        font-size: 13px
    }
    ::v-deep .v-data-table-header {
        background-color: #f6f6f6;
    }
    .pagination {
        padding-top: 20px;
    }
    ::v-deep .v-pagination {
      justify-content: flex-end;
    }
    ::v-deep .v-chip__content {
        font-size: 13px;
        display: flex;
        justify-content: center;
    }
    .v-chip.v-size--default {
        border-radius: 8px
    }
    .v-chip {
        display: inline-block;
    }
    .main-container-content-nonEmptyState {
        width: 68%;
        display: flex;
        flex-direction: column;
    }
    .nonEmptyStateGrowth {
        min-height: 56px;
        background: #F2F6FF;
        width: 100%;
        height: auto;
        padding: 10px;
        display: flex;
        flex-direction: row;
    }
    .values-container {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
    }
    .images-container {
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }
    .referralLinkText {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        color: #4f4f4f;
        margin-bottom: 0px;
    }
    #growthImage {
        margin-right: 5px;
        height: auto;
        width: 22px;
    }
    .bannerIcons {
        color: #4F4F4F;
        cursor: pointer;
        margin-right: 10px;
        font-size: 22px !important;
    }
    .transactionIcons {
        color: #00C292;
        margin-right: 10px;
        font-size: 21px !important;
    }
    .growth-account-value {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 5px;
        margin-bottom: 0px;
        font-weight: 700;
        font-size: 18px;
        color: #4f4f4f;
        width: max-content;
    }

    @media (max-width: 1200px) {
        .main-container-content-nonEmptyState {
            width: 65%;
        }
        .nonEmptyState {
            padding: 9px;
        }
        .referralLinkText {
            font-size: 15px;
        }
        .growth-account-value {
            font-size: 15px;
        }
    }
    @media (max-width:768px){
        .main-container-content-nonEmptyState {
            width: 85%;
        }
        .nonEmptyStateGrowth {
            padding: 9px;
        }
        .referralLinkText {
            font-size: 14px;
        }
        .growth-account-value {
            font-size: 14px;
        }
    }
    @media (max-width: 480px) {
        .main-container-content-nonEmptyState {
            width: 100%;
        }
        .nonEmptyStateGrowth {
            padding: 8px;
        }
        .referralLinkText {
            font-size: 15px;
        }
        .growth-account-value {
            font-size: 15px;
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
            font-size: 11px
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
            font-size: 11px
        }
        ::v-deep .v-chip__content {
            font-size: 11px;
        }
        .bannerIcons {
            font-size: 19px !important;
        }
        #growthImage {
            width: 19px;
        }
        .transactionAmount {
            font-size: 13px;
        }
        .fundDate {
            font-size: 11px;
        }
        .description {
            font-size: 13px;
        }
        .transactionIcons {
            font-size: 18px !important;
        }
    }
</style>
